import React, { useMemo } from 'react';
import {
  ActionInfoList,
  statusMapper,
  ActionInfoListItem,
} from '@erecruit/ui-kit';
import { Resources } from '@erecruit/types';

enum ApprovalPathStepActionKind {
  'Approved',
  'Rejected',
}

export type Statuses = 'Approved' | 'Rejected' | 'Pending';

type ApproversListProps = Pick<
  Resources.ApprovalPathStep,
  'eligibleApprovers'
> & {
  pathStepActions: Resources.ApprovalPathStep['actions'];
};

const ApproversList = ({
  eligibleApprovers,
  pathStepActions,
}: ApproversListProps) => {
  const actions: ActionInfoListItem<Statuses>[] = useMemo(
    () =>
      pathStepActions.map(({ createdBy, createdOn, kind, note }) => ({
        user: createdBy.name,
        status: ApprovalPathStepActionKind[kind] as Statuses,
        lastRefreshed: createdOn,
        infoDescription: { description: note },
      })),
    [pathStepActions],
  );

  const approvers: ActionInfoListItem<Statuses>[] = useMemo(
    () =>
      eligibleApprovers.map(({ name }) => ({
        user: name,
        status: 'Pending',
      })),
    [eligibleApprovers],
  );

  return (
    <ActionInfoList
      items={[...actions, ...approvers]}
      statusMapper={statusMapper}
    />
  );
};

export default ApproversList;
